import {createAction} from 'redux-actions';
import callApi from "../../../utils/api/axios";

const ALL_FUNDS = 'ALL_FUNDS';

function pivotFundsByTicker(funds) {
  const byTicker = {};
  if (funds === undefined) {
    return {};
  }
  funds.forEach((fund) => (byTicker[fund.ticker] = fund));
  return byTicker;
}

export default function allFunds(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    funds: [],
    byTicker: {},
    collegeFundsMap: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${ALL_FUNDS}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${ALL_FUNDS}_FULFILLED`:
      return Array.isArray(payload.data)
        ? {
            ...state,
            isLoading: false,
            isLoaded: true,
            funds: payload.data,
            byTicker: pivotFundsByTicker(payload.data),
          }
        : {
            ...state,
            isLoading: false,
            isLoaded: true,
            collegeFundsMap: payload.data,
          };
    case `${ALL_FUNDS}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        hasFailed: true,
        error: payload,
      };
    default:
      return state;
  }
}

export const getTRPFunds = () => {  return (dispatch) => {
    const action = createAction(ALL_FUNDS)(callApi(`/self-serve-service-api/service/agreements/fund-list?productType=MutualFund&transactionType=Exchange`));
    dispatch(action);
  };
}
